import validate from "/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import nuxt_45server_45init_45global from "/app/app/middleware/nuxt-server-init.global.ts";
import manifest_45route_45rule from "/app/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  nuxt_45server_45init_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "rtk-check": () => import("/app/app/middleware/rtk-check.ts")
}